import {UICalendarDay, UICalendarWeek} from '@lib/store';
import {LocalDateString} from '@lib/store/src/data/timeslots/apiTypes';
import {addDays, addWeeks, eachDayOfInterval, format, getISOWeek, isSameDay, startOfISOWeek} from 'date-fns';

export const localStartOfDateForDateKey = (dateKey: LocalDateString) => {
  // Validate dateKey is in yyyy-MM-dd format
  if (!/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) {
    console.warn('Warning: wrong date key passed; will try to still return a date');
    return new Date(dateKey);
  }

  /* 
    Note: T00:00 ensures we get local midnight back.
    Example:
      Sao Paolo timezone
        new Date("2025-07-21")       -> Sun Jul 20 2025 21:00:00 GMT-0300 (Horário Padrão de Brasília)
        new Date("2025-07-21T00:00") -> Mon Jul 21 2025 00:00:00 GMT-0300 (Horário Padrão de Brasília)
  
    This means that if you do `format(..., "yyyy-MM-dd")` you are guaranteed to get the same key back
    Since all of our formatting works on local times, this is usually what we want
  */
  const localString = `${dateKey}T00:00`; // Note: no UTC (Z)!

  return new Date(localString);
};

export const constructCalendarWeeks = (todayKey: LocalDateString) => {
  const WEEKS_VISIBLE = 4;

  const today = localStartOfDateForDateKey(todayKey);

  const refDates = eachDayOfInterval(
    {
      start: today,
      end: addWeeks(today, WEEKS_VISIBLE - 1),
    },
    {step: 7},
  );

  return refDates.map((d, i): UICalendarWeek => {
    const weekNumber = getISOWeek(d);
    const weekStart = startOfISOWeek(d);

    return {
      weekNumber,
      weekType: i === 0 ? 'thisWeek' : i === 1 ? 'nextWeek' : 'futureWeek',
      data: eachDayOfInterval({
        start: weekStart,
        end: addDays(weekStart, 6),
      }).map((wd): UICalendarDay => {
        return {
          date: format(wd, 'yyyy-MM-dd'),
          isToday: isSameDay(today, wd),
          weekNumber,
        };
      }),
    };
  });
};
